import { __assign, __read } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { Icon } from "../icon";
import { noop } from "../_util/noop";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
var iconMap = {
    info: { name: "info-fill", color: "#006eff" },
    success: { name: "success-fill", color: "#07c160" },
    error: { name: "warning-fill", color: "#ff584c" },
    warning: { name: "warning-fill", color: "#ff9c19" },
};
export function Alert(_a) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? "info" : _c, hideIcon = _a.hideIcon, icon = _a.icon, children = _a.children, onClick = _a.onClick, _d = _a.closeable, closeable = _d === void 0 ? false : _d, _e = _a.onClose, onClose = _e === void 0 ? noop : _e, _f = _a.duration, duration = _f === void 0 ? 0 : _f, className = _a.className, style = _a.style;
    var classPrefix = useConfig().classPrefix;
    var timerRef = useRef(null);
    var _g = __read(useState(false), 2), closeAlert = _g[0], setCloseAlert = _g[1];
    useEffect(function () {
        clearTimeout(timerRef.current);
        if (duration) {
            timerRef.current = setTimeout(function () {
                onClose();
                setCloseAlert(true);
            }, duration);
        }
    }, [duration, onClose]);
    useEffect(function () { return function () {
        clearTimeout(timerRef.current);
    }; }, []);
    var iconProps = typeof icon === "string" ? { name: icon } : icon;
    if (!iconProps && iconMap[type]) {
        iconProps = iconMap[type];
    }
    return (React.createElement(View, { className: classNames(classPrefix + "-alert", classPrefix + "-alert--" + type, className, {
            "is-close": closeAlert,
            "with-suffix": closeable || onClick,
        }), style: style, onClick: onClick || noop },
        !hideIcon && iconProps ? (React.createElement(Icon, __assign({ color: (_b = iconMap[type]) === null || _b === void 0 ? void 0 : _b.color, size: TaroEnv ? 40 : 20 }, iconProps, { className: classNames(classPrefix + "-alert__icon", iconProps.className) }))) : null,
        React.createElement(View, { className: classPrefix + "-alert__text" }, children),
        onClick && (React.createElement(Icon, { className: classPrefix + "-alert__chevron", name: "chevronright" })),
        !onClick && closeable && (React.createElement(View, { onClick: function () {
                onClose();
                setCloseAlert(true);
            } },
            React.createElement(Icon, { className: classPrefix + "-alert__close", name: "close" })))));
}
//# sourceMappingURL=Alert.js.map